// In src/components/ProtectedRoute.js

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children }) => {
  const { currentUser, isInitialized } = useAuth();

  // If the auth state is still being determined, show a loading spinner.
  if (!isInitialized) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // If initialization is finished and there's no user, redirect to login.
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // If initialization is finished and there IS a user, show the page.
  return children;
};

export default ProtectedRoute;